import { useEffect, useState, useRef } from "react";
import LinearLayout from "../components/layout/LinearLayout";
import TextView from "../components/textview/TextView";
import { useParams, useNavigate } from "react-router-dom";

import RatingBar from "../components/ratingbar/RatingBar";
import axios from "../utils/axiosInstance";
import Toolbar from "../containers/Header/Toolbar/Toolbar";
import BreadCrumb from "../components/breadcrumb/BreadCrumb";
import ImageGallery from "../components/imagegallery/ImageGallery";
import AttributesTable from "../components/list/AttributesTable";
import ProductRightPanel from "../components/product/ProductRightPanel";
import { toast } from "react-toastify";

import "./page.css"; // فایل CSS که ادامه‌ش رو گذاشتم

import Footer from "../containers/Footer/Footer";
import ProductRecyclerview from "../components/layout/ScrollView/ProductRecyclerview";
import useDynamicTabTitle from "../useDynamicTabTitle";

const DesktopProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
  // sheet state
  const [sheetVisible, setSheetVisible] = useState(false); // آیا نوار پایین ظاهر شود (compact)
  const [sheetExpanded, setSheetExpanded] = useState(false); // آیا sheet کامل باز شده؟
  const [specsModalOpen, setSpecsModalOpen] = useState(false); // مودال مشخصات
  useDynamicTabTitle(product ? product.title : "Loading...");
  const navigate = useNavigate();
  const handleSelectProduct = (product) => {
    navigate(`/product/${product._id}`);
  };
  const tickingRef = useRef(false);
  useEffect(() => {
    if (id) {
      axios
        .get(`/products/${id}/related`)
        .then((res) => {
          if (res.data.status) setRelatedProducts(res.data.data);
          console.log("related", res.data.data);
        })
        .catch((err) => console.error("خطا در دریافت محصولات مرتبط:", err));
    }
  }, [product]);
  useEffect(() => {
    axios
      .get(`/products/${id}`)
      .then((res) => {
        if (res.data && res.data.status) {
          setProduct(res.data.data);

          axios
            .get(`/categories/${res.data.data.categoryId._id}/path`)
            .then((res) => {
              setBreadcrumbs(res.data);
            })
            .catch((err) => {
              console.error("خطا در دریافت breadcrumb:", err);
            });
        } else {
          setProduct(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching product:", err);
        setLoading(false);
      });
  }, [id]);
  useEffect(() => {
    if (sheetExpanded) {
      document.body.style.overflow = "hidden"; // قفل شدن بک‌گراند
    } else {
      document.body.style.overflow = "auto"; // آزاد شدن
    }
  }, [sheetExpanded]);

  // show/hide bottom sheet on scroll (throttled with requestAnimationFrame)
  useEffect(() => {
    let lastScroll = window.scrollY;
    const mobileMax = 767;

    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (window.innerWidth <= mobileMax) {
        // اسکرول به بالا → sheet ظاهر شود
        if (currentScroll < lastScroll && currentScroll > 200) {
          setSheetVisible(false);
        }
        // اسکرول به پایین → sheet مخفی شود
        else if (currentScroll > lastScroll) {
          setSheetVisible(true);
        }
      }

      lastScroll = currentScroll;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // اضافه: scroll داخل خود sheet را هم کنترل کنیم
    const sheet = document.querySelector(".custom-bottom-sheet");
    if (sheet) {
      sheet.addEventListener("scroll", handleScroll, { passive: true });
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (sheet) sheet.removeEventListener("scroll", handleScroll);
    };
  }, [sheetExpanded]);

  const addToCart = async (productId, quantity = 1) => {
    try {
      const res = await axios.post("/cart/add", { productId, quantity });
      if (res.data.status) {
        toast.success("محصول با موفقیت به سبد خرید اضافه شد 🛒");
      } else {
        toast.error("خطا در افزودن به سبد خرید");
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
      toast.error(err.response?.data?.message || "مشکلی پیش آمد");
    }
  };

  const toggleExpandSheet = () => {
    setSheetExpanded((s) => !s);
    // وقتی expand شد compact نباید نمایش داده بشه
    if (!sheetExpanded) setSheetVisible(false);
  };

  if (loading) return <div className="text-center p-5">Loading...</div>;
  if (!product) return <div className="text-center p-5">Product not found</div>;

  return (
    <>
      <Toolbar />
      <div className="product-detail-container">
        <BreadCrumb breadcrumbs={breadcrumbs} />
        <div className="product-main">
          <div className="product-left">
            <div className="d-none d-md-block">
              <LinearLayout
                orientation="horizontal"
                height="match-parent"
                width="match-parent"
              >
                <LinearLayout
                  orientation="vertical"
                  height="match-parent"
                  width="match-parent"
                  xgravity="start"
                >
                  <TextView margin="1" size="lg" bold={true}>
                    {product?.title}
                  </TextView>
                  <RatingBar margin={"3"} size={"5"} value={4.5} />
                  <ImageGallery images={product?.images} margin={3} />
                </LinearLayout>

                <ProductRightPanel
                  price={product?.price}
                  discount={product?.discount}
                  stock={product?.stock}
                  onAddToCart={addToCart}
                  product={product}
                />
              </LinearLayout>
            </div>
          </div>
        </div>
        <LinearLayout>
          <h5>Related Product</h5>
          <ProductRecyclerview
            items={relatedProducts}
            onItemClick={handleSelectProduct}
          />
        </LinearLayout>
        <div className="d-none d-md-block">
          <div className="mt-3">
            <h5>Description</h5>
            <p>{product?.description}</p>
          </div>
          <AttributesTable attributes={product?.attributes} />

          <Footer />
        </div>
      </div>
    </>
  );
};

export default DesktopProductDetail;


